import authApi from '@/authApi';
import { useI18n } from '@/i18n';
import { useRouter } from '@/router';
import { redirect } from '@/router/location';

export function useLogin ({ redirectUri, brandTemplate }) {
  const i18n = useI18n();
  const router = useRouter();

  return {
    async login ({ username, password, otp }) {
      const res = await authApi.post('login', {
        username,
        password,
        redirectUri,
        brandTemplate,
        otp
      });
      if (!res) {
        return { message: i18n.t('login.network-error') };
      } else if (res.status === 422) {
        return { message: res.data.errors[0].message };
      } else if (res.status !== 200) {
        return { message: i18n.t('login.unexpected-error') };
      } else if (res.data.showTwoFactorAuth) {
        return { ...res.data };
      } else if (res.data.isPasswordResetRequired) {
        // User authenticated successfully but is required to update
        // their password before continuing
        router.push({
          name: 'UpdatePassword',
          query: {
            redirect_uri: res.data.redirectUri
          }
        });
      } else {
        // Use sanitized URI to avoid open redirect
        // https://cheatsheetseries.owasp.org/cheatsheets/Unvalidated_Redirects_and_Forwards_Cheat_Sheet.html
        redirect(res.data.redirectUri);
      }
    },
    async updatePassword ({ password }) {
      const res = await authApi.put('password', {
        password,
        redirectUri
      });
      if (!res) {
        return i18n.t('login.network-error');
      } else if (res.status === 200) {
        redirect(res.data.redirectUri);
      } else if (res.status === 401) {
        // User isn't authenticated. They either came to the page manually,
        // their session timed out while they were sitting on the page, or
        // they logged out in another tab.
        router.push('/login');
      } else if (res.status === 422) {
        // Client validation should prevent this but we still want to show
        // a more descriptive error message in case we made a mistake.
        return res.data.errors[0].message;
      } else {
        return i18n.t('login.unexpected-error');
      }
    }
  };
}
